import { makeRequest } from '../makeRequest';
import { LIVE_CHAT_CONVERSATIONS } from '../requestResources';

export const getMessagingConversations = () =>
  makeRequest('GET', LIVE_CHAT_CONVERSATIONS);

export default {};
